/**
 *
 * Asynchronously loads the component for PassagePage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
